import React, {useEffect, useState} from 'react'
import WebFontLoader from "webfontloader";
import _ from "lodash";
import {GOOGLE_FONTS} from "./google-fonts";
import SearchBox from "../ui/search-box";
import {FONT_FAMILY_LIST} from "../constants/designer.constant";
import GoogleFontLoader from "react-google-font-loader";
import GoogleWebFontLoader from "./google-web-font-loader";

const SelectFonts = ({parentForm, handleFontDetailsChanges}) => {
    const [googleFontsList, setGoogleFontsList] = useState(GOOGLE_FONTS);
    const [fontFamilyList, setFontFamilyList] = useState(FONT_FAMILY_LIST);
    const [selectedFont, setSelectedFont] = useState(parentForm?.fontFamily);
    const [selectedFontKey, setSelectedFontKey] = useState(null);
    const [showFonts, setShowFonts] = useState(false);
    const [isGoogleFont, setIsGoogleFont] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);

    useEffect(() => {
        if (initialLoad) {
            WebFontLoader.load({
                google: {
                    families: GOOGLE_FONTS
                },
            });
        }
    }, [initialLoad]);

    /*const loadAllFonts = () => {
        WebFontLoader.load({
            custom: {
                families: FONT_FAMILY_LIST
            },
            timeout: 60000
        });

        WebFontLoader.load({
            google: {
                families: GOOGLE_FONTS
            },
            timeout: 60000
        });
    }*/

    const handleGoogleFontFamilyChange = (fontItem) => {
        setSelectedFont(fontItem);
        setSelectedFontKey(fontItem);
        const event = {
            target: {
                name: 'fontFamily',
                value: fontItem,
                type: 'text'
            }
        };
        handleFontDetailsChanges(event, parentForm);
        setIsGoogleFont(true);
    }

    const handleFontFamilyChange = (fontItem, origin) => {
        setSelectedFont(fontItem.fontName);
        setSelectedFontKey(fontItem.fontKey);
        const event = {
            target: {
                name: 'fontFamily',
                value: fontItem.fontName,
                type: 'text'
            }
        };
        handleFontDetailsChanges(event, parentForm);
        setIsGoogleFont(false);
    }

    return (
        <>
            {/*<GoogleFontLoader
                fonts={_.map(GOOGLE_FONTS, (font) => {
                    return {
                        font: font,
                    }
                })}
            />*/}
            <div className={'w-full'}>
                <div className="flex justify-between">
                    {isGoogleFont &&
                        <button
                            className={`button-purple-outline w-full px-3 py-2 gfont-${_.kebabCase(selectedFont)}`}
                            onClick={() => {
                                setShowFonts(!showFonts);
                            }}>
                            {selectedFont ? selectedFont : 'Choose Font'}
                        </button>
                    }

                    {!isGoogleFont &&
                        <button
                            className={`ml-2 button-purple-outline w-full px-3 py-2 text-family-${selectedFontKey}`}
                            onClick={() => {
                                setShowFonts(!showFonts);
                            }}>
                            {selectedFont ? selectedFont : 'Choose Font'}
                        </button>
                    }
                </div>

                {showFonts &&
                    <div className={'flex justify-start items-start'}>
                        <div
                            className="w-1/2 mr-1 my-2 max-h-48 justify-start bg-white content-start overflow-y-scroll border border-purple-600 rounded">
                            {googleFontsList?.map((fontItem, index) => (
                                <div key={index}
                                     id={`menu-${_.kebabCase(fontItem)}`}
                                     className={`cursor-pointer px-2 py-1 w-full ${selectedFontKey === fontItem ? 'font-family-card-selected' : ''}`}
                                     onClick={() => {
                                         handleGoogleFontFamilyChange(fontItem)
                                     }}>
                                    <div
                                        className={`gfont-${_.kebabCase(fontItem)}`}>{fontItem}</div>
                                </div>
                            ))}
                        </div>

                        <div
                            className="w-1/2 ml-1 my-2 max-h-48 justify-start bg-white content-start overflow-y-scroll border border-purple-600 rounded">
                            {fontFamilyList?.map((fontItem, index) => (
                                <div key={index}
                                     id={`menu-${_.kebabCase(fontItem.fontName)}`}
                                     className={`cursor-pointer px-2 py-1 w-full ${selectedFontKey === fontItem.fontKey ? 'font-family-card-selected' : ''}`}
                                     onClick={() => {
                                         handleFontFamilyChange(fontItem, 'menu')
                                     }}>
                                    <div
                                        className={`${fontItem.fontKey ? 'text-family-' + fontItem?.fontKey : ''}`}>{fontItem.fontName}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                }

                <GoogleWebFontLoader/>
            </div>
        </>
    );
}

export default SelectFonts
